export const faqs = [
  {
    q: 'Czy to działa w grupach o każdym poziomie?',
    a: 'Tak. Każda sesja ma Wersję A dla początkujących, Wersję B dla średniozaawansowanych i Wersję C dla zaawansowanych. Te same zajęcia bez problemu poprowadzisz w grupie mieszanej.',
  },
  {
    q: 'W jakiej walucie płacę?',
    a: 'Płacisz w złotówkach (PLN) — jednorazowo 79 zł. Ostateczną kwotę zobaczysz przed potwierdzeniem płatności. Bez ukrytych opłat i bez niespodzianek.',
  },
  {
    q: 'Jak otrzymam materiały?',
    a: 'Natychmiastowy dostęp w ciągu 5 minut. Po płatności dostajesz e-mail z osobistym linkiem. Pobierasz wszystkie 6 tomów w PDF — pliki zostają u Ciebie NA ZAWSZE. Wydrukuj je albo korzystaj z nich prosto z telefonu, tabletu lub komputera.',
  },
  {
    q: 'Czy potrzebuję specjalnego sprzętu?',
    a: 'NIE — wystarczy podstawowy sprzęt. Sesje wykorzystują sztangi, hantle, kettlebelle, skrzynie plyo, TRX i maty. Jeśli Twoja siłownia ma podstawowe wyposażenie, MASZ WSZYSTKO.',
  },
  {
    q: 'Czy to dla mnie, jeśli jestem instruktorem na siłowni, a nie nauczycielem WF?',
    a: 'TAK — 70% naszych klientów to instruktorzy siłowni. Trening Funkcjonalny 365 powstał dla nauczycieli WF, instruktorów fitness, trenerów CrossFit, trenerów personalnych i trenerów przygotowania motorycznego.',
  },
  {
    q: 'Czy gwarancja jest prawdziwa?',
    a: 'W 100% — bez formularzy i bez kombinowania. Kup dziś, a jeśli w ciągu 7 dni materiały Cię nie przekonają, wyślij nam e-mail i zwrócimy Ci pieniądze. Nie zapytamy o powód. O zwrot prosi mniej niż 2% osób.',
  },
  {
    q: 'Dopiero zaczynam — czy muszę znać się na programowaniu treningu?',
    a: 'NIE. Nie musisz znać periodyzacji ani zaawansowanej teorii. Każda sesja jest JUŻ rozpisana: cel, ćwiczenia i serie. Otwierasz, czytasz, prowadzisz. Sprawdza się zarówno u początkujących, jak i u doświadczonych trenerów — 40% naszych klientów dopiero zaczyna.',
  },
  {
    q: 'Czy mogę korzystać z tego w więcej niż jednej grupie?',
    a: 'TAK — bez limitu, ze wszystkimi Twoimi grupami. Jedna płatność = dożywotni dostęp. 1 grupa, 5 grup czy 20 grup — bez żadnych ograniczeń.',
  },
]
